import {
	LOGIN_USER,
	LOGIN_USER_SUCCESS,

	AUTH_ERROR,
	
	LOGOUT_USER,

	REGISTER_USER, REGISTER_USER_SUCCESSFUL, REGISTER_USER_FAILED
} from './actionTypes';

export const loginUser = (credentials, history) => {
    return {
        type: LOGIN_USER,
        payload: { credentials, history }
    }
}

export const loginSuccess = (user) => {
    return {
        type: LOGIN_USER_SUCCESS,
        payload: user
    }
}

export const logoutUser = (history) => {
    return {
        type: LOGOUT_USER,
        payload: { history }
    }
}

export const authError = (error) => {
    return {
        type: AUTH_ERROR,
        payload: error
    }
}


export const registerUser = (user) => {
    return {
        type: REGISTER_USER,
        payload: { user }
    }
}

export const registerUserSuccessful = (user) => {
    return {
        type: REGISTER_USER_SUCCESSFUL,
        payload: user
    }
}

export const registerUserFailed = (user) => {
    return {
        type: REGISTER_USER_FAILED,
        payload: user
    }
}
